<div class="flex" style="margin-top: 15px;" *ngIf="assets && assets.length > 0">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="assets"
        [totalRecords]="totalAssets"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [autoLayout]="true"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [sortOrder]="-1"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        styleClass="p-datatable-striped"
        sortField="alias"
        responsiveLayout="stack"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="alias">
              {{'attribute.alias' | transloco}}<p-sortIcon field="alias"></p-sortIcon></th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="assetRepresentation.name">
              {{'model.representation' | transloco}}<p-sortIcon field="assetRepresentation.name"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-asset>
          <tr *ngIf="!loadingAssets">
            <td>
              <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
              <a [routerLink]="'/assets/' + asset.uuid + '/details'">{{asset.alias}}</a>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{asset.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.representation' | transloco}}</span>
              {{asset.assetRepresentation ? asset.assetRepresentation.name : ''}}
            </td>
          </tr>
          <tr *ngIf="loadingAssets">
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalAssets == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalAssets > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalAssets ? totalAssets : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalAssets}}
            {{(totalAssets > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="assets && assets.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.assets' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!assets && loadingAssets">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
